import __ from "lodash";
import React, { Component } from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { cekCookies } from "../../../../../actions";
import accountManagement from "../../../../../apis/accountManagement";
import { CONFIG } from "../../../../../config";
import KelasParalelSearch from "../../../../../entity/KelasParalelSearch";
import KelasSearch from "../../../../../entity/KelasSearch";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import DropdownKelas from "../../masterDropDown/DropdownKelas";
import DropdownKelasParalel from "../../masterDropDown/DropdownKelasParalel";
import DropdownTahunAjaran from "../../masterDropDown/DropdownTahunAjaran";

class RekomendasiSnmptn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            resMessage: "",
            ta: [],
            kelas: [],
            KelasParalelSearch: [],
            idKelasParalel: null,
            tipeCbt: "Rekomendasi SNBP",
            kodeAspek: "",
            kodeTa: null,
            idKelas: null,
            idKp: null,
            idJadwal: null,
            idProfilCbt: null,
            jadwalCbt: [],
            kodeSubTipe: "",
            kelompok: "",
            isShowDdKelasParalel: true,
            isShowBtnRekapSbmptn: false,
            urlAkm: "http://18.140.135.175:3000/",
            namaJadwalCbt: null,
            // urlAkm : 'http://localhost:3000/',
        };
    }

    async componentDidMount() {
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchTa();
            this.fetchKelas();
        }
        this.setState({ isFetching: false });
    }

    fetchTa = async () => {
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function (error) {});
        if (resTa) {
            if (resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    ta: resTa.data.data,
                });
            }
        }

        resTa.data.data.map((val) => {
            if (val.status == "1") {
                this.setState({ kodeTa: val.kodeTahunAjaran });
            }
        });
    };

    fetchKelas = async () => {
        this.setState({ isFetching: true });
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function (error) {});
        let kodeJenjang = null;
        if (resSekolah) {
            if (resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                kodeJenjang = resSekolah.data.data.kodeJenjangSekolah;
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, { KelasSearch, ["kodeJenjangSekolah"]: kodeJenjang }).catch(function (error) {});
        // masukan data kelas ke dropdown
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: response.data.data,
                });
            }
        }
        this.setState({ isFetching: false });
    };

    fetchJadwal = async (idKelas, kodeTa) => {
        this.setState({ isFetching: true, jadwalCbt: [] });
        const response = await accountManagement
            .get(CONFIG.REPORT_CBT_GET_JADWAL, {
                params: {
                    tahunAjaran: kodeTa,
                    idSekolah: this.props.account.idSekolah,
                    idKelas: idKelas,
                    tipeCbt: this.state.tipeCbt,
                },
            })
            .catch(function (error) {
                console.log(error);
            });

        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    jadwalCbt: response.data.data,
                    namaJadwalCbt: response.data.data[0].namaJadwalCbt,
                });
            }
        }
        this.setState({ isFetching: false });
    };

    hanldeOnChangeTa = async (e) => {
        this.setState({ kodeTa: e.target.value, jadwalCbt: [] });
        if (this.state.idKelas !== null) {
            this.fetchJadwal(this.state.idKelas, e.target.value);
        }
    };

    handleOnChangeKelas = async (idKelas) => {
        this.setState({
            idKelas: idKelas.target.value,
            isShowBtnRekapSbmptn: false,
            isShowDdKelasParalel: true,
            jadwalCbt: [],
            idJadwal: "",
            kelompok: "",
        });

        this.setState({ isFetching: true });
        this.state.KelasParalelSearch = [];
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, { KelasParalelSearch, ["idKelas"]: idKelas.target.value, ["idSekolah"]: this.props.account.idSekolah }).catch(function (error) {});

        // masukan kelas paralel ke  dropdown
        if (resKelasParalel) {
            if (resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data,
                });
            }
        }

        if (this.state.kodeTa !== null) {
            this.fetchJadwal(this.state.idKelas, this.state.kodeTa);
        }
        this.setState({ isFetching: false });
    };

    handleOnChangeKelasParalel = async (e) => {
        this.setState({
            idKelasParalel: e.target.value,
        });
        if (!__.isEmpty(e.target.value)) {
            this.setState({
                idKp: e.target.value,
            });
        }
    };

    handleOnChangeJadwal = async (e) => {
        this.setState({ idJadwal: e.target.value });

        this.state.jadwalCbt.map((val, i) => {
            if (e.target.value == val.idJadwalCbt) {
                this.setState({
                    idProfilCbt: val.idProfilCbt,
                    kodeSubTipe: val.kodeSubTipeCbt,
                    namaJadwalCbt: val.namaJadwalCbt,
                });
                if (val.kodeSubTipeCbt == "SBMPTN") {
                    // console.log('=================SBMPTN')
                    this.setState({
                        isShowDdKelasParalel: false,
                        isShowBtnRekapSbmptn: true,
                    });
                } else {
                    // console.log('=================NO SBMPTN')
                    this.setState({
                        kelompok: "",
                        isShowDdKelasParalel: true,
                        isShowBtnRekapSbmptn: false,
                    });
                }
            }
        });
    };

    handleClick(e) {
        console.log(e.target.id);
        if (this.state.idKp === null || this.state.idKelas === null) {
            alert("Parameter Harus Dipilih semua...");
            e.preventDefault();
        }
    }

    render() {
        const { jadwalCbt } = this.state;
        let params = {
            tipeCbt: this.state.tipeCbt,
            idSekolah: this.props.account.idSekolah,
            idKelas: this.state.idKelas,
            idKelasParalel: this.state.idKp,
            idJadwalCbt: this.state.idJadwal,
            kodeTa: this.state.kodeTa,
        };
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title={"Rekomendasi SNBP"} />
                    {this.loadAlert()}
                    <Row>
                        <Col sm={7}>
                            <Col>
                                <select className="form-control" value={this.state.kodeTa} onChange={this.hanldeOnChangeTa} required>
                                    <option value="" selected disabled>
                                        ~~ Pilih Tahun Ajaran ~~
                                    </option>
                                    <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                </select>
                            </Col>
                            <Col style={{ marginTop: "10px" }}>
                                <select className="form-control" value={this.state.idKelas} onChange={this.handleOnChangeKelas} required>
                                    <option value="" selected disabled>
                                        ~~ Pilih Kelas ~~
                                    </option>
                                    <DropdownKelas kelas={this.state.kelas} />
                                </select>
                            </Col>
                            <Col style={{ marginTop: "10px" }}>
                                <select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel}>
                                    <option value="" selected>
                                        ~~ Pilih Kelas Paralel ~~
                                    </option>
                                    <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                                </select>
                            </Col>
                            <Col style={{ marginTop: "15px" }}>
                                <Link to={{ pathname: "/report_rekomendasi_snmptn" + "/" + this.state.kodeTa + "/" + this.state.idKelas + "/" + this.state.idKp }} target="_blank" onClick={(e) => this.handleClick(e)}>
                                    <button className="btn btn-success" title="REKOMENDASI PTN">
                                        Rekomendasi
                                    </button>
                                </Link>
                            </Col>
                        </Col>

                        <Col sm={5}>
                            <h5>Keterangan: </h5>
                            <p>Untuk melihat report per kelas, kosongi pilihan opsi Kelas Paralel.</p>
                            <p>
                                <i className="fa fa-check text-success" aria-hidden="true"></i> Siswa selesai mengerjakan<i onClick={this.reportSekolahSta}>.</i>
                            </p>
                            <p>
                                <i className="fa fa-remove text-danger" aria-hidden="true"></i> Siswa belum/tidak selesai mengerjakan.
                            </p>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(RekomendasiSnmptn);
